import { render, staticRenderFns } from "./RoleViewPage.vue?vue&type=template&id=4f59d55e&scoped=true&"
import script from "./RoleViewPage.vue?vue&type=script&lang=ts&"
export * from "./RoleViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./RoleViewPage.vue?vue&type=style&index=0&id=4f59d55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59d55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VCol,VIcon,VSimpleTable})
